// ⚠️ FILE SINH TỰ ĐỘNG bởi scripts/gen-i18n-shims.mjs — đừng sửa tay.
// Cụm: pages-marketplace
import { messages } from '../../../locales/vi/pages-marketplace.mjs';
import { registerCluster } from '../runtime.js';

const loaders = {
  en: () => import('../../../locales/en/pages-marketplace.mjs'),
  fr: () => import('../../../locales/fr/pages-marketplace.mjs'),
  es: () => import('../../../locales/es/pages-marketplace.mjs'),
};

registerCluster('pages-marketplace', messages, (locale) => loaders[locale]());
